routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('notifications', {
      url: '/notifications',
      template: require('./index.html'),
      controller: 'NotificationsController',
      controllerAs: 'not',
      authRequired: true
    })
}



// WEBPACK FOOTER //
// ./src/app/features/notifications/routes.js